import gql from 'graphql-tag';

import remoteItemFromProviderFragment from './remoteItemFromProviderFragment';

export const googleDriveRemoteItemsPageFragment = gql`
  fragment googleDriveRemoteItemsPageFragment on GoogleDriveRemoteItemsPage {
    dokkioClass
    nextPageToken
    remoteItems {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
export default googleDriveRemoteItemsPageFragment;
